module.exports = __webpack_public_path__ + "static/media/caffe2.c585db83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backends/caffe2.svg
// module id = 316
// module chunks = 0